<template>
  <div class="QR-box">
        <div class="QR-img">
            <vue-qr
                id="loginQr"
                class="qrcode"
                :text="loginUrl"
                :margin="3"
                color-dark="#000"
                color-light="#fff"
                :dot-scale="1"
                :size="260"
            ></vue-qr>
            <div v-if="qrStatus === 'U'" class="QR-mask" @click="getScanCode"> 
              <div class="QR-mask-content">
                  <img src="../images/刷新.png" alt="">
                  <span >刷新后请重新扫码</span>
              </div>
            </div>
            <div v-if="qrStatus == 'Y'" class="QR-mask">
              <div class="QR-mask-content">
                  <img src="../images/QR-success.png" alt="" width="26" height="26">
                <span >请在手机上确认登录</span>
              </div>
            </div>
        </div>
        <div class="QR-tip">
            <div class="QR-scan">
                <img src="../images/scan.png" alt="">
            </div>
            <div class="QR-text" style="width:216px">
                在 <span style="color:rgba(49, 76, 243, 1);">{{ APP_WINNY_NAME }} App</span>,点击个人资料图标，然后按右上角的图标扫描二维码
            </div>
        </div>
  </div>
</template>

<script>
/* global http protocol util BaseApi hqWs hqProtocol*/
import vueQr from 'vue-qr'
export default {
  name:'QR',
  components: {
    vueQr
  },
  data(){
    return{
        APP_WINNY_NAME: window.g.APP_WINNY_NAME,
        loginUrl:'',
        qrStatus: null, // 二维码状态 状态：W：待扫码 Y：已扫码 O：已登录 U：已失效
        qrTime: null,
        qrTimeStatus: false,
        btnDisenable:false,
    }
  },
  destroyed(){
    console.log('destroy');
  },
  methods:{
    changLoginWay(){
      this.qrTimeStatus = true
      this.getScanCode()
    },
    clearCode() {
      this.qrTimeStatus = false
    },
     // 生成二维码
    getScanCode() {
      // if (this.btndisable) {
      //   return
      // }
      this.btnDisenable = true
      protocol.param_getScanCode.param.scanCode = null
      http.postFront(protocol.param_getScanCode).then(response => {
        this.btnDisenable = false
        var { value, code, message } = response.data
        if (Number(code) === 0 && value) {
          // 生成二维码
          // value.status 状态：W：待扫码Y：已扫码O：已登录U：已失效
          this.qrStatus = value.status // 二维码状态
          if (value.status === 'W') {
            const logCode = JSON.stringify({ scanCode: value.scanCode })
            protocol.param_getScanCode1.param.scanCode = value.scanCode
            this.loginUrl = logCode
            // 启动轮询
            if (this.qrTime) {
              clearTimeout(this.qrTime)
              this.qrTime = null
            }
            this.qrTime = setTimeout(() => {
              if (this.qrTimeStatus) {
                this.getScanCode1()
              }
            }, 1000)
          } else {
            this.$message(message)
          }
        } else {
          this.$message(message)
        }
      }).catch(error => {
        this.btnDisenable = false
        this.$message(error)
      })
    },
      // 轮询二维码登录接口
    getScanCode1() {
      if (this.qrStatus === 'W' || this.qrStatus === 'Y') {
        http.postFront(protocol.param_getScanCode1).then(response => {
          var { value, code, message } = response.data
          if (Number(code) === 0 && value) {
            // 生成二维码
            // value.status 状态：W：待扫码Y：已扫码O：已登录U：已失效
            this.qrStatus = value.status
            if (value.status === 'Y') {
              // 已扫码
            } else if (value.status === 'O') {
              // 已登录 获取登录信息,自动登录并跳转首页
              this.qrloginWithData(value.repBody)
            } else if (value.status === 'U') {
              // 已失效
            }
          } else {
            this.$message(message)
          }
        })
        if (this.qrTime) {
          clearTimeout(this.qrTime)
          this.qrTime = null
        }
        this.qrTime = setTimeout(() => {
          if (this.qrTimeStatus) {
            this.getScanCode1()
          }
        }, 1000)
      }
    },
    qrloginWithData(repBody) {
      // 登录信息提取函数
      function parseRepBodyToJSON(data) {
        // 提取RAuthnReturn后的括号内容
        const content = data.match(/RAuthnReturn\((.+)\)/)[1]

        // 将提取的内容分割为键值对数组
        const pairs = content.split(', ')

        // 构建对象
        const obj = {}
        pairs.forEach(pair => {
          const [key, value] = pair.split('=')
          // 处理特殊值null
          obj[key.trim()] = value === 'null' ? null : value.trim()
        })

        return obj
      }
      const value = parseRepBodyToJSON(repBody)

      let self = this
      let tel = value.cellphone
      // 清除历史账号访问交易页面商品缓存信息
      this.$store.commit('item', {})
      if (value && value.banTime) {
      
        this.$message(value.banTime)
        return
      }
      // 当记住密码的checbox选中时，像localStorage里存入一下用户输入的用户名和密码
      if (self.checked == true) {
        self.setlocalStorage(self.ruleForm.tel, self.ruleForm.passWord)
      } else {
        self.setlocalStorage('', '')
      }
      const sessionInfo = {}
      sessionInfo.isLogin = true
      sessionInfo.userId = value.userId
      sessionInfo.sessionStr = value.sessionStr
      sessionInfo.firmCode = value.userCode
      sessionInfo.tel = value.cellphone
      sessionInfo.firmId = value.firmId
      sessionInfo.userType = value.type
      sessionInfo.userName = value.userName
      sessionInfo.lnvitationCode = value.lnvitationCode
      this.$store.commit('setSessionInfo', sessionInfo)
      // 为扫码跳移动端做准备
      const urlQr = `cellPhone=${tel}&lnvitationCode=${value.lnvitationCode}&sessionStr=${value.sessionStr}&type=${value.type}&userCode=${value.userCode}&userId=${value.userId}&userName=${value.userName}`
      localStorage.setItem('qrContent', urlQr)
      localStorage.setItem('myPhone', tel)
      const sessionStr = value.sessionStr
      const sessionUserId = value.userId
      const sessionFirmId = value.firmId
      const sessionFirmCode = value.userCode
      const sessionTel = tel
      const lnvitationCode = value.lnvitationCode
      const sessionUserType = value.type
      const userName = value.userName
      // 将session信息存到localstorage中
      sessionStorage.sessionStr = sessionStr
      sessionStorage.sessionUserId = sessionUserId
      sessionStorage.sessionFirmCode = sessionFirmCode
      sessionStorage.sessionTel = sessionTel
      sessionStorage.userType = sessionUserType
      localStorage.setItem('lnvitationCode_w', lnvitationCode)
      localStorage.setItem('userName', userName)
      // 修改请求参数的登录信息
      for (const item in protocol) {
        if (protocol[item].param) {
          if ('sessionStr' in protocol[item].param) {
            protocol[item].param.sessionStr = sessionStr
            protocol[item].param.userId = sessionUserId
          }
        }
      }
      for (const key in protocol) {
        if (protocol[key].param) {
          if ('firmId' in protocol[key].param) {
            protocol[key].param.firmId = sessionFirmId
          }
          if ('ffirmId' in protocol[key].param) {
            protocol[key].param.ffirmId = sessionFirmId
          }
          if ('firmCode' in protocol[key].param) {
            protocol[key].param.firmCode = sessionFirmCode
          }
          if ('tel' in protocol[key].param) {
            protocol[key].param.tel = sessionTel
          }
        }
        if (protocol[key].data) {
          if ('firmIds' in protocol[key].data) {
            protocol[key].data.firmIds = sessionFirmId
          }
          if ('firmId' in protocol[key].data) {
            protocol[key].data.firmId = sessionFirmId
          }
        }
      }
      // this.userRiskTimePastDue()
      console.log('----------------');
      this.queryCommodityStrategy() // 更新商品策略信息并跳转登录后页面
      // this.getMoneyPwdFlgByFirmId()
      // this.sendMsgLoginInformation() // 发送短信
      // this.btnEnable = false
    },
        // 像localStorage里存入从页面获取的用户名和密码；
    setlocalStorage(c_tel, c_pwd) {
      localStorage.sitetel = c_tel
    },
            // 商品策略查询
    queryCommodityStrategy() {
      const _this = this
      http.postFront(protocol.param_queryCommodityStrategy).then((response) => {
        const { code, message, value } = response.data
        if (code == 0) {
          this.$store.commit('setQueryTradeAuthArr', value)
          this.$store.commit('setCommodityStrategy', value)
          hqWs.send(hqProtocol.param_SYMBOLS)
          hqWs.send(hqProtocol.param_businessJb)
          if (value.length > 0) {
            this.$router.push('/quotationList')
          } else {
            this.$message('暂未关联商品')
            this.$router.push('/quotationListNosession')
          }
        } else {
          this.$message(message)
          // this.$router.push('/quotationList')
          setTimeout(() => {
            _this.queryCommodityStrategy()
          }, 1000)
        }
      }).catch((e) => {
        setTimeout(() => {
          _this.queryCommodityStrategy()
        }, 1000)
      })
    },
  }
}
</script>

<style lang='scss'>

.QR-box{
   width: 100%;
   height: 100%;
}
.QR-mask{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #333333;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    .QR-mask-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: Source Han Sans SC;
      font-weight: 200;
      font-size: 10px;
      color: #FFFFFF;
      line-height: 10px;
      img{
        width: 30px;
        height: 27px;
      }
     
    }
}
.QR-img{
    position: relative;
    width: 130px;
    height: 130px;
    margin-left: 50%;
    transform: translateX(-125%);

    img{
      width: 100%;
      height: 100%;
      margin-bottom: 12px;
    }
}
.QR-tip{
     margin-left: 54%;
     margin-top: 26px;
    transform: translateX(-80%);
    width: 291px;
    display: flex;
    align-items: center;
    font-family: Source Han Sans SC;
    font-weight: 200;
    font-size: 12px;
    line-height: 20px;
    color: #333333;
    .QR-scan{
        width: 24px;
        height: 24px;
        margin-right: 10px;
        flex-shrink: 0;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>